'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemeProvider = function (_Component) {
    (0, _inherits3.default)(ThemeProvider, _Component);

    function ThemeProvider() {
        (0, _classCallCheck3.default)(this, ThemeProvider);
        return (0, _possibleConstructorReturn3.default)(this, (ThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(ThemeProvider)).apply(this, arguments));
    }

    (0, _createClass3.default)(ThemeProvider, [{
        key: 'getChildContext',

        /* eslint-enable react/forbid-prop-types */

        value: function getChildContext() {
            return {
                themr: {
                    theme: this.props.theme,
                    styling: this.props.styling
                }
            };
        }
        /* eslint-disable react/forbid-prop-types */

    }, {
        key: 'render',
        value: function render() {
            return _react.Children.only(this.props.children);
        }
    }]);
    return ThemeProvider;
}(_react.Component);

ThemeProvider.propTypes = {
    children: _propTypes2.default.element.isRequired,
    theme: _propTypes2.default.object.isRequired,
    styling: _propTypes2.default.object.isRequired };
ThemeProvider.defaultProps = {
    theme: {},
    styling: {}
};
ThemeProvider.childContextTypes = {
    themr: _propTypes2.default.shape({
        theme: _propTypes2.default.object.isRequired,
        styling: _propTypes2.default.object.isRequired
    })
};
exports.default = ThemeProvider;
//# sourceMappingURL=ThemeProvider.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/roc-package-hyperion/~/@spp/theme-provider/lib/cjs/ThemeProvider.js
 ** module id = 280
 ** module chunks = 1
 **/